import { schema } from "normalizr";
import { ShippingCarrier as ShippingCarrierRecord } from "records/shipping-accounts";

export const ShippingCarrier = new schema.Entity(
    "shippingCarrier",
    {},
    {
        idAttribute: "id",
    }
);

(ShippingCarrier as any).record = ShippingCarrierRecord;
